import { of } from 'rxjs';
import { BoostOffersCountResponse, EdrBalanceResponseV2, RewardMessagesResponse } from '@woolworthsnz/trader-api';

export const mockEdrBalance: EdrBalanceResponseV2 = {
	accountStatus: 'Active',
	redemptionPreference: EdrBalanceResponseV2.RedemptionPreferenceEnum.SpendNow,
	totalPointsBalance: 2500,
	isPointsRedeemable: true,
	redeemablePointsBalance: 2000,
	redeemablePointsAsVoucherDollars: 15,
	redeemablePointsAsVoucherCount: 1,
	pointsAsVoucherDollars: 15,
	pointsAsVoucherCount: 1,
	pointsUntilNextReward: 500,
	pointsPerReward: 2000,
};

export const mockRewardMessagesResponse: RewardMessagesResponse = {
	rewardMessages: [
		{
			messageId: '22b72cbb-312b-403a-bacd-b20d029377e6',
			type: 'save_for_occasion_unlock',
			createdDateTime: '2024-11-15T02:38:19.683Z',
			data: {
				vouchersUnlockedValue: 15,
				vouchersUnlockedCount: 1,
				vouchersUnlockedDate: '2024-11-14T11:00:00Z',
			},
		},
		{
			messageId: 'fbde19b6-df40-4a97-9782-a7f509ea47f1',
			type: 'voucher_earn',
			createdDateTime: '2024-11-15T02:39:13.175Z',
			data: {
				currentVouchersValue: 30,
				currentVouchersCount: 2,
			},
		},
		{
			messageId: '7d24997a-c479-40a9-b6ff-47bd6d4b48d9',
			type: 'airnz_burn',
			createdDateTime: '2024-11-15T02:51:47.825Z',
			data: {
				airNZMemberId: '12345',
				airNZPointsEarned: 500,
				edrPointsBurned: 2000,
			},
		},
		{
			messageId: 'cc79c34c-bde4-471a-aaeb-bbe5eb14cd20',
			type: 'qantas_burn',
			createdDateTime: '2024-11-15T02:51:54.063Z',
			data: {
				qantasMemberId: '4444',
				qantasPointsEarned: 2000,
				edrPointsBurned: 4000,
			},
		},
	],
};

export const mockBoostOffersCount: BoostOffersCountResponse = {
	totalOffers: 5,
};

export const mockEdrFacade = {
	edrBalance$: of(mockEdrBalance),
	fetchingEdrBalance$: of(false),
	fetchedEdrBalance$: of(true),
	boostOffersCount$: of(mockBoostOffersCount.totalOffers),
	fetchingBoostOffersCount$: of(false),
	fetchedBoostOffersCount$: of(true),
	hasError$: of(false),
	fetchEdrBalance: (): void => {
		/* Mock Fetch EDR Balances */
	},
	fetchBoostOffersCount: (): void => {
		/* Mock Fetch Boost Offers Count */
	},
	redemptionPreference$: of(EdrBalanceResponseV2.RedemptionPreferenceEnum.SpendNow),
	rewardMessages$: of(mockRewardMessagesResponse.rewardMessages),
	fetchingRewardMessages$: of(false),
	fetchedRewardMessages$: of(true),
	deletingRewardMessage$: of(false),
	deletedRewardMessage$: of(false),
	fetchRewardMessages: (): void => {
		/* Mock Fetch EDR Reward Messages */
	},
};
